import { render, staticRenderFns } from "./OppositeSlot.vue?vue&type=template&id=549a97e8&"
import script from "./OppositeSlot.vue?vue&type=script&lang=js&"
export * from "./OppositeSlot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports